import { render, staticRenderFns } from "./RootDipartimentiUnitnView.vue?vue&type=template&id=e8ad4ffa&"
import script from "./RootDipartimentiUnitnView.vue?vue&type=script&lang=ts&"
export * from "./RootDipartimentiUnitnView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports